var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHomeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5665_9782)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5605 5.53553L8.76801 1.74253C8.29863 1.27453 7.66284 1.01172 7.00001 1.01172C6.33718 1.01172 5.70139 1.27453 5.23201 1.74253L1.43951 5.53553C1.29972 5.67442 1.18889 5.83968 1.11345 6.02172C1.038 6.20377 0.999445 6.39898 1.00001 6.59603V11.5045C1.00001 11.9024 1.15804 12.2839 1.43935 12.5652C1.72065 12.8465 2.10218 13.0045 2.50001 13.0045H11.5C11.8978 13.0045 12.2794 12.8465 12.5607 12.5652C12.842 12.2839 13 11.9024 13 11.5045V6.59603C13.0006 6.39898 12.962 6.20377 12.8866 6.02172C12.8111 5.83968 12.7003 5.67442 12.5605 5.53553V5.53553ZM8.50001 12.0045H5.50001V10.0375C5.50001 9.63971 5.65804 9.25818 5.93935 8.97687C6.22065 8.69557 6.60218 8.53753 7.00001 8.53753C7.39783 8.53753 7.77936 8.69557 8.06067 8.97687C8.34197 9.25818 8.50001 9.63971 8.50001 10.0375V12.0045ZM12 11.5045C12 11.6371 11.9473 11.7643 11.8536 11.8581C11.7598 11.9519 11.6326 12.0045 11.5 12.0045H9.50001V10.0375C9.50001 9.37449 9.23662 8.73861 8.76777 8.26976C8.29893 7.80092 7.66305 7.53753 7.00001 7.53753C6.33697 7.53753 5.70108 7.80092 5.23224 8.26976C4.7634 8.73861 4.50001 9.37449 4.50001 10.0375V12.0045H2.50001C2.3674 12.0045 2.24022 11.9519 2.14645 11.8581C2.05268 11.7643 2.00001 11.6371 2.00001 11.5045V6.59603C2.00047 6.46352 2.0531 6.33652 2.14651 6.24253L5.93901 2.45103C6.22086 2.1705 6.60234 2.013 7.00001 2.013C7.39767 2.013 7.77916 2.1705 8.06101 2.45103L11.8535 6.24403C11.9465 6.33766 11.9992 6.46404 12 6.59603V11.5045Z",
    fill: "#787878"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5665_9782"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeIcon);
export default __webpack_public_path__ + "static/media/Home-Icon.09aa458f05d74b8ec3b574b82d63b0ae.svg";
export { ForwardRef as ReactComponent };